// @flow
import * as React from 'react';
import classNames from '@ta/common.classnames';
import { Icon } from '@ta/styleguide.icon';
import styles from './LabeledIconAction.less';

type Props = {
  label: React.Node,
  icon: React.Node,
  url: ?string,
  onClick: ?(SyntheticMouseEvent<*>) => void,
};

type ContainerProps = {
  url: ?string,
  onClick: ?(SyntheticMouseEvent<*>) => void,
  children: React.Node,
};

const LabeledIconContainer = (props: ContainerProps) =>
  props.url ? (
    <a href={props.url} className={styles.item} onClick={props.onClick}>
      {props.children}
    </a>
  ) : (
    <button className={classNames(styles.item, styles.unstyledButton)} onClick={props.onClick}>
      {props.children}
    </button>
  );

const LabeledIconAction = (props: Props) => (
  <LabeledIconContainer {...props}>
    {typeof props.icon === 'string' ? (
      <Icon className={styles.itemIcon} name={props.icon} />
    ) : (
      props.icon
    )}
    {typeof props.label === 'string' ? (
      <span className={styles.itemLabel}>{props.label}</span>
    ) : (
      props.label
    )}
  </LabeledIconContainer>
);
LabeledIconAction.defaultProps = {
  onClick: null,
  url: null,
  isGlobalNavLabeledIcon: false,
  isHambugerMenuLabeledIcon: false,
};

export default LabeledIconAction;
